// Other Firebase email actions keep using the project's original hosted handler.
function defaultEmailActionUrl(query, { projectId, apiKey, origin }) {
  if (!/^[a-z0-9-]+$/.test(projectId || "") || !apiKey)
    throw new Error("A configuração de confirmação da conta está indisponível.");
  const source = new URLSearchParams(query);
  const target = new URL(`https://${projectId}.firebaseapp.com/__/auth/action`);
  for (const key of ["mode", "oobCode", "lang", "tenantId"]) {
    if (source.has(key)) target.searchParams.set(key, source.get(key));
  }
  target.searchParams.set("apiKey", apiKey);
  const continuation = source.get("continueUrl");
  if (continuation) {
    try {
      const url = new URL(continuation);
      if (url.origin === origin && !url.username && !url.password)
        target.searchParams.set("continueUrl", url.href);
    } catch {
      /* An invalid continuation must not change the trusted destination. */
    }
  }
  return target.href;
}
module.exports = { defaultEmailActionUrl };
